import type { AppState } from '../store'
import { downloadReferrer } from './constants'

export const selectRedirectUri = (state: AppState) => state.startup.redirectUri
export const selectWithDownloadReferrer = (state: AppState) => state.startup.referrer === downloadReferrer
